import { render, staticRenderFns } from "./ServerForm.vue?vue&type=template&id=24817ac4&scoped=true&"
import script from "./ServerForm.vue?vue&type=script&lang=js&"
export * from "./ServerForm.vue?vue&type=script&lang=js&"
import style0 from "./ServerForm.vue?vue&type=style&index=0&id=24817ac4&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24817ac4",
  null
  
)

export default component.exports